<template>
  <div class="banner-wrap">
    <div class="banner-body">
      <div class="img-box">
        <img :src="src" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: require("@a/img/banner-news.png")
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
img {
  max-width: 100%;
}

@media only screen and (max-width: 767px) {
  .img-box img {
    // height: 80px;
  }
}
</style>
